import Dialog from '../../../../../global/Mui/Dialog';
import BagPinImg from '../../../../../images/bag-pin-image.webp';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../../global/Button';
import './PinModal.scss';
import InfoSection from '../../../../../global/InfoSection/InfoSection';
import FindingPinInBox from '../../../Components/Animations/FindingPinInBox';

export default function PinModal({
  isOpen,
  onClose,
  isTechRecycling,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="PinModal">
        <InfoSection
          titleText={`Find your ${isTechRecycling ? 'box' : 'bag'} PIN`}
        />
        <div className="PinModal__img">
          {isTechRecycling ? (<FindingPinInBox />) : (
            <img src={BagPinImg} alt="check" />
          )}
        </div>
        <Button
          className="PinModal__button"
          type={BUTTON_TYPE.QUATERNARY}
          size={BUTTON_SIZE.LARGE}
          onClick={onClose}
        >
          CLOSE
        </Button>
      </div>
    </Dialog>
  );
}
